// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-13bzJ","btnDetail":"index-btnDetail-2cqNK"};